import { computed } from "vue";

import { EstimateItem } from "../../entities/estimate";
import { CreateOneStrategy } from "../base/creation.strategy";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { Pricing } from "@/app/domain";

export class EstimateItemTotalCreationStrategy extends CreateOneStrategy {
    constructor(
        estimateItemList: EstimateItem[],
    ) {
        const estimateStore = useNewEstimateStore();
        const dealType = computed(() => estimateStore.estimate.dealTypeCode);

        const sumPrices = (array, property) => {
            const sumValue = array.reduce((acc, item) => acc + item[property].getSystemPrice(dealType.value).getValue()
                , 0).toFixed(2);
            return +sumValue || 0;
        }

        const overheadPrice = sumPrices(estimateItemList, "overheadPrice");
        const servicePrice = sumPrices(estimateItemList, "servicePrice");
        const price = sumPrices(estimateItemList, "price");
        const sum = sumPrices(estimateItemList, "sum");

        const estimateItemTotalConfig = {
            overheadPrice: new Pricing(overheadPrice, overheadPrice, overheadPrice),
            servicePrice: new Pricing(servicePrice, servicePrice, servicePrice),
            price: new Pricing(price, price, price), //material price
            sum: new Pricing(sum, sum, sum), // partition total
        };

        super(estimateItemTotalConfig, EstimateItem);
    }
}



